<script lang="ts">
  import { onMount } from "svelte";
  import { createEventDispatcher } from "svelte";
  import type { IDropdownItem } from "../../services/DTO/dropdown-item";
  import SearchDropdown from "../Form/Fields/Dropdown/SearchDropdown.svelte";
  import { TransportDocumentService } from "../../services/transport-document.service";

  export let placeholder: string = "";
  export let required: boolean = false;
  export let disabled: boolean = false;
  export let clearVisible: boolean = false;
  export let filterVisible: boolean = true;
  export let name: string = "";
  export let value: number | null = null;
  export let small: boolean = false;

  const dispatch = createEventDispatcher();

  let items: IDropdownItem[] = [];

  function onFilter(event: CustomEvent) {
    let filter: string = event.detail;
    search(filter);
  }

  async function search(filter: string) {
    let selfId = !!value ? value : 0;
    let values = await TransportDocumentService.searchTransportDocumentForSectionCombo(selfId, filter);
    items = values.payload || [];
  }

  function onSelect(event: CustomEvent | null) {
    if (event == null) {
      dispatch("clear");
    } else {
      dispatch("select", event.detail);
    }
  }

  onMount(() => search(""));
</script>

<SearchDropdown
  {placeholder}
  {required}
  {disabled}
  {clearVisible}
  {filterVisible}
  {name}
  {items}
  {small}
  bind:value
  on:filter={onFilter}
  on:select={onSelect}
  on:clear={(_) => onSelect(null)}
/>
